import React from 'react';
import SvgPdf from '../../../../assets/icons/Pdf';
import IconsComponents from '../Styles/styledComponent';

function Pdf() {
  return (
    <IconsComponents.Container>
      <SvgPdf />
    </IconsComponents.Container>
  );
}

export default Pdf;
